export enum BackgroundType {
	Color,
	Image,
	NineSliceImage
}
